/**
 * Are arguments objects or not?
 */
export function arePlainObjects() {
    var result = true,
        i;
    for(i = 0; i < arguments.length; i++) {
        result = (
            typeof arguments[i] === 'object'
            && (
                (Object.getPrototypeOf && Object.getPrototypeOf(arguments[i]) === {})
                || arguments[i].constructor === Object // IE8 fallback
            )
        );
        if (!result) { break; }
    }
    return result;
}

/**
 * Puts a value under a given namespace.
 */
export function assign(namespace, data) {
    var i,
        obj = window,
        parts = namespace.split('.'),
        len = parts.length;
    for (i = 0; i < len; i++) {
        if (obj === null || typeof obj !== 'object' && typeof obj !== 'function') {
            throw new Error('No subitem can be defined in a non-object element: ' + namespace);
        }
        if (i === len - 1) {
            if (arePlainObjects(obj[parts[i]], data)) {
                obj[parts[i]] = merge(obj[parts[i]], data);
            } else {
                obj[parts[i]] = data;
            }
        } else if (typeof obj[parts[i]] === 'undefined') {
            obj[parts[i]] = {};
        }
        obj = obj[parts[i]];
    }
}

/**
 * Gets a value from the given namespace.
 */
export function retrieve(namespace) {
    var i,
        obj = window,
        parts = namespace.split('.');
    for (i = 0; i < parts.length; i++) {
        obj = obj[parts[i]];
        if (obj === undefined) {
            break;
        }
    }
    return obj;
}

/**
 * This function provides shortcut functions to a module's API functions
 *
 * The attrs parameter is an object with the below properties:
 * - 'module': the module's name,
 * - 'namespace': the namespace string under which the functions will be exposed,
 * - 'apiFunctions': an array of function names to expose in the module under the given namespace
 *    as public API functions.
 *
 * E.g.:
 * shortcut({
 *     module: dataTable,
 *     namespace: 'uwr.datatable',
 *     apiFunctions: ['fill', 'sort']
 * });
 * will create the following shortcut methods: uwr.datatable.fill(), uwr.datatable.sort()
 * and they will delegate the call to the respective methods of the given module.
 */
export function shortcut(attrs) {
    var moduleName = attrs.module,
        namespace = attrs.namespace,
        functionName,
        functionNames = attrs.apiFunctions,
        i,
        len = functionNames.length;
    for (i = 0; i < len; i++) {
        functionName = functionNames[i];
        assign(namespace + '.' + functionName, moduleName[functionName]);
    }
}

/**
 * Returns the full resource URL of uwr.js that is used on the page.
 * On IE7 and older, for relative paths it will return the same relative path.
 * If uwr.js is loaded with src="http://ubs.com/main/uwr.js" in the script tag, then this method
 * returns 'http://ubs.com/main'.
 * If uwr.js is loaded with "lib/uwr.js", then this method will still return the full URL of the resource,
 * e.g., 'http://ubs.com/main/lib' (in IE7 it would be "lib").
 */
export function getUwrResourcePath() {
    var scripts = document.getElementsByTagName('script'),
        script,
        src,
        uwrJsPath = '',
        i,
        foundAt;
    for (i = 0; i < scripts.length; i++) {
        script = scripts.item(i);
        src = script.src;
        if (src && (foundAt = src.indexOf('/uwr.js')) !== -1) {
            uwrJsPath = src.substring(0, foundAt);
            break;
        }
    }
    return uwrJsPath;
}

function mergeObjects(obj1, obj2) {
    var prop;
    for (prop in obj2) {
        if (obj2.hasOwnProperty(prop)) {
            if(arePlainObjects(obj1[prop], obj2[prop])) {
                obj1[prop] = mergeObjects(obj1[prop], obj2[prop]);
            } else {
                obj1[prop] = obj2[prop];
            }
        }
    }
    return obj1;
}

/**
 * Merges the properties of objects into the first object. The objects will be merged one after the other,
 * with the last one merged last. Non-object arguments will be skipped. The first argument must be an object,
 * otherwise undefined will be returned. The merging goes in-depth, the objects within the parameter objects are
 * merged too.
 * @param {object} The target object.
 * @param {...object} The objects to merge into the target object.
 * @return {object} The first argument with all the other objects merged into that. If there are no arguments
 *      or the first one is not an object, undefined will return.
 */
export function merge() {
    var target,
        i,
        obj;

    if (arguments.length > 0 && arePlainObjects(arguments[0])) {
        target = arguments[0];
        for (i = 1; i < arguments.length; i++) {
            obj = arguments[i];
            if (arePlainObjects(obj)) {
                mergeObjects(target, obj);
            }
        }
    }
    return target;
}



//////////////////
// WEBPACK FOOTER
// ./loader/util.js
// module id = 3
// module chunks = main